import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { ArrowRightCircleFill } from 'react-bootstrap-icons'

import {
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
} from '../../styles'

export function DadosFiscais({ isVisible, onNext, product, handleChange }) {
  if (!isVisible) {
    return null
  }

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Dados Fiscais</h4>

          <Row className="mb-3">
            <Col>
              <Form.Label>Tipo Produto</Form.Label>
              <Form.Select
                name="TIPO"
                value={product.TIPO}
                onChange={(e) => handleChange(e, 'dadosFiscais')}
              >
                <option value="PRD">PRODUTO</option>
                <option value="SRV">SERVIÇO</option>
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>NCM</Form.Label>
              <Form.Control
                name="CODNCM"
                value={product.CODNCM}
                onChange={(e) => handleChange(e, 'dadosFiscais')}
              />
            </Col>

            <Col>
              <Form.Label>CFOP NF-e</Form.Label>
              <Form.Control
                name="CFOPNFE"
                value={product.CFOPNFE}
                onChange={(e) => handleChange(e, 'dadosFiscais')}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>CFOP NFC-e</Form.Label>
              <Form.Control
                name="CFOPNFCE"
                value={product.CFOPNFCE}
                onChange={(e) => handleChange(e, 'dadosFiscais')}
              />
            </Col>

            <Col>
              <Form.Label>CFOP Entrada</Form.Label>
              <Form.Control
                name="CFOPENTRADA"
                value={product.CFOPENTRADA}
                onChange={(e) => handleChange(e, 'dadosFiscais')}
              />
            </Col>

            <Col>
              <Form.Label>CFOP Saída</Form.Label>
              <Form.Control
                name="CFOPSAIDA"
                value={product.CFOPSAIDA}
                onChange={(e) => handleChange(e, 'dadosFiscais')}
              />
            </Col>
          </Row>
        </ContentComponent>

        <FooterComponent>
          <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
            <NextButton onClick={onNext}>
              <ArrowRightCircleFill
                size={15}
                color="white"
              />
            </NextButton>
          </OverlayTrigger>
        </FooterComponent>
      </div>
    </ContainerComponent>
  )
}
